import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  OfferTable,
  OfferTableFilters,
  useDefaultHtzOfferListRequest,
} from "@/services/backend/htz/offers/components/offer-table";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import { CreateOfferButton } from "@/services/backend/htz/offers/components/create-offer-button";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function OfferIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  const [request, setRequest] = useState(
    useDefaultHtzOfferListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!data) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Angebote")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Angebote")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <OfferTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateOfferButton
                processId={processId!}
                onCreated={(offerId: string) => navigate(offerId)}
              />
            </div>
            <OfferTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
